import { render, staticRenderFns } from "./NoMatchDetail.vue?vue&type=template&id=79cdeaa0"
import script from "./NoMatchDetail.vue?vue&type=script&lang=ts"
export * from "./NoMatchDetail.vue?vue&type=script&lang=ts"
import style0 from "./NoMatchDetail.vue?vue&type=style&index=0&id=79cdeaa0&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports